<template>
  <v-navigation-drawer
    v-model="drawer"
    clipped
    app
    dark
    permanent
    hide-overlay
    width="170px"
    class="rai-app-sidenav"
  >
    <v-list>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        link
        class="pr-0"
        exact
        :to="item.route"
        :disabled="item.disabled"
      >
        <v-list-item-icon class="mr-1">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="overline rai-list-item">{{ $t(item.title) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <span class="rai-front-version">{{ versionNumber }}</span>
  </v-navigation-drawer>
</template>

<script>
import userRightMixin from '@/mixins/user-right-mixin.js';
import { mapState } from 'vuex';

export default {
  name: "AppSidenav",

  mixins: [ userRightMixin ],

  data () {
    return {
      drawer: true,
      versionNumber: '',
    }
  },

  computed: {
    items () {
      const projId = this.project ? this.project.id : '';
      let items = [
        { order: 1, title: 'sidenav.dashboard', icon: 'mdi-view-dashboard-outline', route: '/', disabled: false },
        { order: 12, title: 'sidenav.project', icon: 'mdi-webpack', route: '/projects/' + projId, disabled: !this.project },
        { order: 13, title: 'sidenav.scenarii', icon: 'mdi-format-list-checkbox', route: '/projects/' + projId + '/scenariiList', disabled: !this.project },
        { order: 14, title: 'sidenav.search', icon: 'mdi-magnify', route: '/searchPage' },
        { order: 18, title: 'sidenav.testProject', icon: 'mdi-test-tube', route: '/projects/' + projId + '/test', disabled: !this.project },
        { order: 30, title: 'sidenav.accountsAndBilling', icon: 'mdi-receipt', route: '/accounts', disabled: false },
      ];

      if (this.isUserParameterizer) {
        items.push(...[
          { order: 15, title: 'sidenav.sourcesAndDeployments', icon: 'mdi-connection', route: '/projects/' + projId + '/sourcesAndDeployments', disabled: !this.project },
        ]);
      }

      return items.sort((a, b) => a.order - b.order);
    },
    ...mapState(['project',]),
  },

  created () {
    this.versionNumber = process.env.VUE_APP_VERSION;
  },
};
</script>

<style>
.rai-app-sidenav {
  background: rgb(163,239,237);
  background: linear-gradient(0deg, #00a19a 0%, #062b89 100%);
  margin-top: 64px;
}

.rai-front-version {
  color: #00a19a;
  font-size: 10px;
  position: absolute;
  bottom: 62px;
  right: 5px;
  cursor: default;
}

.rai-list-item {
  white-space: initial;
}
</style>